


























































































































































































































































































































































































































































































































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {Action, Getter, Mutation, State} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import Label from './Label.vue';
import Axios from "axios";
import alzuhudLink from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        Label,
    },
    data: () => ({
        date: '',
        date2: '',
    })
})
export default class SelectPackage extends Vue {
    @State tabModel: number;
    private menu: boolean = false;
    private menu2: boolean = false;
    private modal: boolean = false;
    private modal2: boolean = false;
    ratingSize: number = 24;
    @Mutation setPage: (page: number) => void;
    @Mutation setHotel: (hotel: {props?:any}) => void;
    @Mutation setFlight: (flight: {props?:any}) => void;
    @Getter token: string;
    @State hotel: { props?:any };
    @State flight: { props?:any };
    @State countries: any[];
    @State userId: number;
    @Mutation setCountry: Function;
    @Mutation setState: Function;
    @Mutation setCity: Function;
    @State country: any;
    private states: any[] = [];
    @State state: any;
    private cities: any[] = [];
    @State city: any;
    private now: any = '';
    private packages: any[] = [];
    @Mutation selectPackageId: Function;
    packagesLoading: boolean = true;
    @State package: any;
    @State title: string;
    @Mutation setPackage: Function;
    @Mutation setNumAdults: Function;
    @Mutation setNumChildren: Function;
    @Mutation setTabModel: Function;
    @Mutation setTitle: Function;
    @Action snackIt: Function;
    @State packageId: any;
    // @Getter totalPrice: any;
    // @Getter totalPackagePrice: any;
    statesLoading: boolean = false;
    citiesLoading: boolean = false;
    hotelsLoading: boolean = true;
    flightsLoading: boolean = true;
    @State isPriceApplied: any;
    @Mutation setPriceApplied: Function;

    @Watch('date')
    setDate(newVal:any, oldVal: any) {
        if (!!newVal){

            this.$router.app.$emit('set date', newVal);
        }
        else
            this.$router.app.$emit('set date', oldVal);
    }

    @Watch('date2')
    setDate2(newVal:any, oldVal: any) {
        if (!!newVal)
            this.$router.app.$emit('set date2', newVal);
        else
            this.$router.app.$emit('set date2', oldVal);
    }

    private get IsPriceApplied(): any {
        return this.isPriceApplied;
    }

    private set IsPriceApplied(payload: any) {
        this.setPriceApplied(payload);
    }

    private get totalPrice(): any {
        // @ts-ignore
        return (this.hotel.price || 0) + (this.package.price || 0);
    }

    private get Title(): any {
        return this.title;
    }

    private set Title(title: any) {
        this.setTitle(title);
    }

    private get TabModel(): any {
        return this.tabModel;
    }

    private set TabModel(item: any) {
        if (this.tabModel === item) {
        } else {
            this.setFlight({});
            this.setHotel({});
            this.setPackage({});
            // this.selectedPackageId = -1;
            this.flightIndex = -1;
            this.hotelIndex = -1;
            this.setTabModel(item);
        }
    }

    private get selectedCountry(): any {
        return this.country;
    }

    private set selectedCountry(val: any) {
        this.setCountry(val);
        this.setState({});
        this.setCity({});
        this.getStates();
        this.getCities();
    }

    private get selectedState(): any {
        return this.state;
    }

    private set selectedState(val: any) {
        this.setState(val);
        this.getCities(true, true);
    }

    private get selectedCity(): any {
        return this.city;
    }

    private set selectedCity(val: any) {
        this.setCity(val);
    }

    split(str: string): string {
        let strData = parseFloat(str);
        let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return data.split('.')[0];
    }

    async getStates(selected: boolean = true) {
        this.statesLoading = true;

        try {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/guest/states`, {
                params: {
                    country_id: this.selectedCountry,
                }
            });

            this.states = response.data.res.map((item: any) => ({
                text: item.stateName,
                value: item.stateId,
            }));


        } catch (e) {

        } finally {
            this.statesLoading = false;
        }
    }

    async getCities(hasState: boolean = false, selected: boolean = true) {
        this.citiesLoading = true;
        if (hasState) {
            try {
                const response = await Axios.get(`http://${alzuhudLink}:8080/api/guest/cities`, {
                    params: {
                        country_id: this.selectedCountry,
                        state_id: this.selectedState,
                    }
                });

                this.cities = response.data.res.map((item: any) => ({
                    text: item.cityName,
                    value: item.cityId,
                }));


            } catch (e) {

            } finally {
                this.citiesLoading = false;
            }
        } else {
            try {
                const response = await Axios.get(`http://${alzuhudLink}:8080/api/guest/cities`, {
                    params: {
                        country_id: this.selectedCountry,
                    }
                });

                this.cities = response.data.res.map((item: any) => ({
                    text: item.cityName,
                    value: item.cityId,
                }))


            } catch (e) {

            } finally {
                this.citiesLoading = false;
            }
        }
    }

    togglePackage(p: any) {
        if (p.id !== this.packageId) {

            this.setPackage(p);
            this.selectPackageId(p.id);
        } else {
            this.setPackage({});
            this.selectPackageId(-1);
        }
    }

    weekday: string[] = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];

    rooms: {text: string, value: string , more?:any }[] = [
        {
            text: 'One-person Room',
            value: '1',
        },
        {
            text: 'Two-person Room',
            value: '2',
        },
        {
            text: 'Three-person Room',
            value: '3',
        },
        {
            text: 'Four-person Room',
            value: '4',
        },
    ];

    hotels: any[] = [];

    rating: number = 0;

    search: string = '';

    flights: any[] = [];

    flightRating: number = 0;

    flightSearch: string = '';

    flightIndex = -1;
    hotelIndex = -1;

    async mounted() {
        this.setPage(1);
        this.setTabModel(0);
        this.changeFont();

        // this.setNumChildren(0);

        this.setFlight({});
        this.setHotel({});

        this.hotelsLoading = true;
        this.flightsLoading = true;

        try {
            const res = await Axios.get(`http://${alzuhudLink}:8080/api/hotels/all`, {
                params: {
                    token: this.token,
                    // accomodation: 2,
                    // search: this.search,
                }
            });

            console.log(res);

            this.hotels = res.data.res.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                location: item.address,
                price: item.price,
                rating: this.getInt(item.accomodation),
                main_img_base64: item.main_img_base64,
            }));

            console.log(this.hotels);

        } catch(e) {
            console.log(e);
        } finally {
            this.hotelsLoading = false;
        }
        try {
            const res2 = await Axios.get(`http://${alzuhudLink}:8080/api/flights/all`, {
                params: {
                    token: this.token,
                }
            });
            this.flights = res2.data.res.data.map((item: any) => ({
                id: item.id,
                logo: !!item.logo_url ? item.logo_url : (!!item.logo_base64 ? item.logo_base64 : ""),
                airline: item.name,
                origin: item.origin_name,
                destination: item.destination_name,
                price: item.price,
                rating: item.rate_avg,
                takeoff_time: item.takeoff_time,
                takeoff_date: new Date(item.takeoff_date),
                return_time: item.return_time,
                return_date: new Date(item.return_date),
            }));
        } catch(e) {
            console.log(e);
        } finally {
            this.flightsLoading = false;
        }


        this.now = new Date(Date.now() - 24 * 60 * 60 * 1000);

        try {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/packages/all`, {});

            this.packages = response.data.res.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                rating: item.rate,
                start_date: item.start_date,
                end_date: item.end_date,
                packageCode: item.code,
                hotel_id: item.hotel_id,
                airline_id: item.airline_id,
                price: item.price,
            }))
        } catch (e) {
        } finally {
            this.packagesLoading = false;
        }

        this.setFlight({});
        this.setHotel({});
    }

    // formatDate(date: any) {
    //     let month = `${date.getMonth() + 1}`;
    //     let day = `${date.getDate()}`;
    //     const year = date.getFullYear();
    //
    //     if (month.length < 2) month = `0${month}`;
    //     if (day.length < 2) day = `0${day}`;
    //
    //     return [year, month, day].join('-');
    // }

    allowedDates (val: any) {return new Date(val) >= this.now};
    /**
     *
     */
    constructor() {
        super();
    }

    async searchHotel() {
        this.hotels = [];
        this.hotelsLoading = true;
        try {
            console.log('search params', this.rating, this.search);
            const res = await Axios.get(`http://${alzuhudLink}:8080/api/hotels/all`, {
                params: {
                    token: this.token,
                    accomodation: this.rating,
                    search: this.search,
                }
            });

            console.log(res)

            this.hotels = res.data.res.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                location: item.address,
                price: item.price,
                rating: this.getInt(item.accomodation),
                main_img_base64: item.main_img_base64,
            }));
        } catch(e) {
            console.log(e);
            this.snackIt({
                message: 'Error loading hotels',
                color: 'error',
                snackbar: true,
            })
        } finally {
            this.hotelsLoading = false;
        }
    }

    async searchFlight() {
        this.flights = [];
        this.flightsLoading = true;
        try {
            const res = await Axios.get(`http://${alzuhudLink}:8080/api/flights/all`, {
                params: {
                    token: this.token,
                    rate: this.flightRating,
                    search: this.flightSearch,
                }
            });


            this.flights = res.data.res.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                location: item.address,
                price: item.price,
                rating: this.getInt(item.accomodation),
            }));
        } finally {
            this.flightsLoading = false;
        }
    }

    getInt(str: string): number {
        const num = str.split(' ');
        switch (num[0].toLowerCase()) {
            case 'one':
                return 1;
            case 'two':
                return 2;
            case 'three':
                return 3;
            case 'four':
                return 4;
            case 'five':
                return 5;
            case 'six':
                return 6;
            default:
                return 0;
        }
    }

    checkTicket(e: MouseEvent): void {
        alert('hello');
    }

    order(i: number): string {
        if (i === 11 || i === 12 || i === 13) {
            return i+'th';
        }
        switch (i % 10) {
            case 1:
                return i+'st';
            case 2:
                return i+'nd';
            case 3:
                return i+'rd';
            default:
                return i+'th';
        }
    }

    selectHotel(item: any) {
        this.setHotel(item);
    }

    selectFlight(item: any, index: number) {
        if (item !== this.flight) {
            this.setFlight(item);
            this.flightIndex = index;
        } else {
            this.setFlight({});
            this.flightIndex = -1;
        }
    }

    resetHotel() {
        this.setHotel({});
        this.rating = 0;
        this.search = '';
    }

    resetFlight() {
        this.setFlight({});
        this.flightSearch = '';
        this.flightRating = 0;
    }

    changeFont(): void {
        if (document.body.clientWidth < 1200) {
            this.ratingSize = 18;
        }
    }

    async beforeDestroy() {

    }
}
